import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Calculator } from './App';


var attach = document.getElementById('react-root');

if (attach) {
  const root = ReactDOM.createRoot(attach);

  root.render(
    <React.StrictMode>
      <Calculator />
    </React.StrictMode>
  );
}
